export const HomeBannerSwiper = {
    init: () => {
        // check every .swiper-slide elment and find the max height
        let maxSlideHeight = 0;
        let swiperSlides = document.querySelectorAll(".banner-swiper-slide");

        swiperSlides.forEach((slide) => {
            if (slide.clientHeight > maxSlideHeight) {
                maxSlideHeight = slide.clientHeight;
                // if maxSlideHeight > 900, and window screen size > 1024 then set it to 900px
                if (maxSlideHeight > 900 && window.innerWidth > 1024) {
                    maxSlideHeight = 900;
                }
                // console.log(maxSlideHeight);
            }
        });

        let mobileImage = document.querySelectorAll(".h-full");
        mobileImage.forEach((image) => {
            image.style.height = `${maxSlideHeight}px`;
        });
        // set the height to the .banner-swiper-slide
        let bannerSwiperSlide = document.querySelectorAll(
            ".banner-swiper-slide"
        );
        bannerSwiperSlide.forEach((slide) => {
            slide.style.height = `${maxSlideHeight}px`;
        });
    },
};
